import styles from './Spacing.module.scss';

type SpacingProps = {
  height?: number;
  mobileHeight?: number;
};

const Spacing = ({ height = 80, mobileHeight }: SpacingProps) => {
  const mobileHeightValue = mobileHeight !== undefined ? mobileHeight : height;

  return (
    <div
      className={styles.spacing}
      style={
        {
          height: `${mobileHeightValue}px`,
          '--desktop-height': `${height}px`,
        } as React.CSSProperties & { '--desktop-height': string }
      }
    />
  );
};

export default Spacing;
